import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IUser } from '~/utils/types'

export interface AuthState {
  token: string | null
  user: IUser | null
  permissions: string[] | null
}

const initialState: AuthState = {
  token: null,
  user: null,
  permissions: null,
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    changeToken: (state: AuthState, action: PayloadAction<string>) => {
      state.token = action.payload
    },
    changeUser: (state: AuthState, action: PayloadAction<IUser>) => {
      state.user = action.payload
    },
    changePermissions(state, action: PayloadAction<string[]>) {
      state.permissions = action.payload
    },
    logoutUser: (state: AuthState) => {
      state.token = null
      state.user = null
      state.permissions = null
    },
  },
})

export const { changeToken, changeUser, changePermissions, logoutUser } = authSlice.actions

export default authSlice.reducer
